import { SecurityContext } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

const googleTranslatePatterns = [
    'translate.googleapis.com',
    'translate.google.com',
    'google translate',
    'googletranslate'
];

const blockedDomains = [
    'translate.googleapis.com',
    'translate.google.com'
];

export function isGoogleTranslateError(error: any): boolean {
    if (!error) return false;
    
    const errorStr = String(error.message || error);
    const stackStr = String(error.stack || '');
    
    return googleTranslatePatterns.some(pattern =>
        errorStr.toLowerCase().includes(pattern) ||
        stackStr.toLowerCase().includes(pattern)
    );
}

export function sanitizeAndValidateUrl(url: string, sanitizer: DomSanitizer): string | null {
    if (!url || typeof url !== 'string') {
        return null;
    }

    new URL(url);
    const sanitizedUrl = sanitizer.sanitize(SecurityContext.URL, url);
    return sanitizedUrl;
}

export function isBlockedDomain(src:string): boolean {
    if (!src) return false;

    try {
        const { hostname } = new URL(src);
        const normalizedHostname = hostname.toLowerCase();
        return blockedDomains.some(domain =>
            normalizedHostname === domain ||
            normalizedHostname.endsWith("." + domain)
        );
    } catch (error) {
        return false;
    }
};
